var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "svg",
      {
        attrs: {
          width: "20",
          height: "23",
          viewBox: "0 0 20 23",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
      },
      [
        _c("rect", {
          attrs: {
            x: "0.5",
            y: "0.5",
            width: "19",
            height: "19",
            rx: "9.5",
            stroke: "#B3B3B3",
          },
        }),
        _c("path", {
          attrs: {
            d: "M11.8677 11.273H13.3333V12.3423H11.8677V14H10.7271V12.3423H6.66663V11.3975L10.4876 6H11.8677V11.273ZM10.7271 11.273V7.40311L8.0011 11.273H10.7271Z",
            fill: "#666666",
          },
        }),
        _c("rect", {
          attrs: {
            x: "9.5",
            y: "20",
            width: "1",
            height: "3",
            rx: "0.5",
            fill: "#CCCCCC",
          },
        }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }